import React, { useRef, useEffect, useState, MutableRefObject } from 'react'
import { logEvent } from '../../Utils'

export function useIntersectionObserver(
  ref: MutableRefObject<Element | null>,
  options: IntersectionObserverInit = {},
  forward: boolean = true,
  analytics?: {
    name: string
    params: any
  } | null
) {
  const [element, setElement] = useState<Element | null>(null)
  const [isIntersecting, setIsIntersecting] = useState(false)
  const observer = useRef<null | IntersectionObserver>(null)

  const cleanOb = () => {
    if (observer.current) {
      observer.current.disconnect()
    }
  }

  useEffect(() => {
    setElement(ref.current)
  }, [ref])

  useEffect(() => {
    if (!element) return
    cleanOb()
    const ob = (observer.current = new IntersectionObserver(
      ([entry]) => {
        const isElementIntersecting = entry.isIntersecting
        if (!forward && !isIntersecting && isElementIntersecting) {
          //Changed to intersecting
          if (analytics) {
            //append eventType
            const appendedAnalytics = analytics?.params ? {
              ...analytics.params,
              eventType: 'impression'
            } : { eventType: 'impression'}
          logEvent(analytics.name, appendedAnalytics)
        }
          setIsIntersecting(isElementIntersecting)
        } else if (!forward && isIntersecting && !isElementIntersecting) {
          //Changed to not intersecting
          setIsIntersecting(isElementIntersecting)
        } else if (forward && !isIntersecting && isElementIntersecting) {
          // Only needed once, destroy the observer
          if (analytics) {
              //append eventType
              const appendedAnalytics = analytics.params ? {
                ...analytics.params,
                eventType: 'impression'
              } : { eventType: 'impression'}
            logEvent(analytics.name, appendedAnalytics)
          }
          setIsIntersecting(isElementIntersecting)
          cleanOb()
        }
      },
      { ...options }
    ))
    ob.observe(element)
    return () => {
      cleanOb()
    }
  }, [element, options])

  return isIntersecting
}
